#import "./SentenceDetails.graphql"
query SentenceGroupSentencesQuery($sentenceGroup: ID!) {
  sentenceGroupSentences(sentenceGroup: $sentenceGroup) {
    ...sentenceDetails
  }
}
